import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    event.preventDefault()
    const index = parseInt(event.params.index)
    this.tabTargets.forEach((tab, i) => {
      tab.dataset.active = String(i === index)
    })
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", parseInt(panel.dataset.index) !== index)
    })
  }
}
